import { DateSelection, Flex, FormControl, InputV2Props, TextV2 } from '@withjoy/joykit';
import React, { useEffect, useState } from 'react';
import TimePicker from '@shared/components/TimePicker/TimePicker';
import { EventDatePickerInputV2 } from '@shared/createEvent/formElements/EventDatePickerInputV2';
import { getFieldMetadata } from '@shared/components/ScheduleEditor/hooks/getFieldMetadata';
import { FieldMetadata } from '@shared/components/ScheduleEditor/hooks/useScheduleFormState';
import { ScheduleEditorData } from '@shared/components/ScheduleEditor/types';
import { combineDateAndTime } from '../combineDateAndTime';

type FormDatePickerProps = {
  fieldName: keyof ScheduleEditorData;
  state: ScheduleEditorData;
  setValue: (key: keyof ScheduleEditorData, value: DateSelection) => void;
  label: string;
  meta: Record<keyof ScheduleEditorData, FieldMetadata>;
} & Omit<InputV2Props, 'value' | 'onChange'>;

function formatAMPM(date: Date | null) {
  if (!date) {
    return '12:00 AM';
  }

  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const minutesString = minutes < 10 ? '0' + minutes : minutes.toString();

  return `${hours}:${minutesString} ${ampm}`;
}

export const FormDatePicker = (props: FormDatePickerProps) => {
  const { state, setValue, fieldName, meta, label } = props;
  const metadata = getFieldMetadata(fieldName, meta);
  const [time, setTime] = useState(formatAMPM(state[fieldName] as Date | null));
  const [date, setDate] = useState(state[fieldName] as Date);

  useEffect(() => {
    const finalDate = combineDateAndTime(date, time);
    setValue(fieldName, finalDate);
  }, [date, time, setValue, fieldName]);

  return (
    <FormControl
      label={<TextV2 typographyVariant="label3">{label}</TextV2>}
      isInvalid={metadata.error}
    >
      <Flex gap="16px">
        <EventDatePickerInputV2
          placement="bottom"
          appendPickerToBody={true}
          value={date}
          onChange={date => {
            setDate(date as Date);
          }}
        />
        <TimePicker
          css={{ height: '100%' }}
          name={`timePicker-${fieldName}`}
          value={time}
          onChange={setTime}
        />
      </Flex>
    </FormControl>
  );
};
